"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(require("./Button"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Button/index.js
 ** module id = 24
 ** module chunks = 0
 **/